const expand = {
  area: { select: 'id,name' },
  dynamicEntity: { select: 'id,displayName' },
};

/**
 * OData select/expand for global entity approvers (by area).
 * Used by createCrudModel via CoreQueries.GlobalEntityApproverByArea.
 */
export default {
  paged: {
    select: 'id,approvalLevel,entityValue,dynamicEntityFieldDisplayText',
    notSelectSearch: 'approvalLevel',
    expand,
  },
  item: {
    select:
      'id,approvalLevel,areaId,dynamicEntityId,dynamicEntityFieldId,dynamicEntityFieldDisplayText,dynamicEntityFieldInternalName,entityValue',
    expand,
  },
  itemDetail: {
    select:
      'id,approvalLevel,entityValue,updated,created,creator,dynamicEntityId,dynamicEntityFieldId,dynamicEntityFieldDisplayText,dynamicEntityFieldInternalName',
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
